import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dialogs-component", {
    ref: _vm.model.modal_name,
    attrs: {
      title: _vm.$t("report_management.modal_report.title"),
      "show-buttons": false,
      width: 1200,
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              VForm,
              {
                ref: "form",
                staticStyle: {
                  "margin-top": "-5px",
                  "margin-right": "5px",
                  "margin-left": "5px",
                },
                attrs: { "lazy-validation": "" },
              },
              [
                _c(
                  "div",
                  { staticClass: "min-w-0 w-full" },
                  [
                    _c(
                      VRow,
                      { staticClass: "mt-1" },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "6" } },
                          [
                            _c("common-input", {
                              attrs: {
                                label: _vm.$t(
                                  "report_management.modal_report.form.id"
                                ),
                                "col-size": 12,
                                disabled: !_vm.model.is_new,
                              },
                              model: {
                                value: _vm.form.id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "id", $$v)
                                },
                                expression: "form.id",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "6" } },
                          [
                            _c("common-input", {
                              attrs: {
                                label: _vm.$t(
                                  "report_management.modal_report.form.code"
                                ),
                                rules: _vm.model.form.rules.code,
                                "col-size": 12,
                              },
                              model: {
                                value: _vm.form.code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "code", $$v)
                                },
                                expression: "form.code",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { staticClass: "mt-1" },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "6" } },
                          [
                            _c("common-input", {
                              attrs: {
                                label: _vm.$t(
                                  "report_management.modal_report.form.title"
                                ),
                                rules: _vm.model.form.rules.title,
                                "col-size": 12,
                              },
                              model: {
                                value: _vm.form.title,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "title", $$v)
                                },
                                expression: "form.title",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "6" } },
                          [
                            _c("common-select", {
                              attrs: {
                                label: _vm.$t(
                                  "report_management.modal_report.form.type"
                                ),
                                rules: _vm.model.form.rules.type,
                                "col-size": 12,
                                items: _vm.model.selects.report_type,
                              },
                              model: {
                                value: _vm.form.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "type", $$v)
                                },
                                expression: "form.type",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { staticClass: "mt-1" },
                      [
                        _c(VCol, { attrs: { cols: "6" } }, [
                          _c(
                            "div",
                            { class: "mb-2 col-md-12" },
                            [
                              _c(VSwitch, {
                                attrs: {
                                  label: _vm.$t(
                                    "report_management.modal_report.form.all_permission"
                                  ),
                                  inset: "",
                                  filled: _vm.readonly,
                                  outlined: !_vm.readonly,
                                  readonly: _vm.readonly,
                                  "hide-details": "auto",
                                },
                                model: {
                                  value: _vm.form.all_permission,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "all_permission", $$v)
                                  },
                                  expression: "form.all_permission",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c(VCol, { attrs: { cols: "6" } }, [
                          _c(
                            "div",
                            { class: "mb-2 col-md-12" },
                            [
                              _vm.form.type === "LOOKERSTUDIO"
                                ? _c(VCombobox, {
                                    attrs: {
                                      filled: _vm.readonly,
                                      outlined: !_vm.readonly,
                                      readonly: _vm.readonly,
                                      "hide-details": "auto",
                                      dense: "",
                                      multiple: "",
                                      label: "Escriba una o varias llaves",
                                      chips: "",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.form.keys,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "keys", $$v)
                                      },
                                      expression: "form.keys",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { staticClass: "mt-1" },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "12" } },
                          [
                            _c("common-input", {
                              attrs: {
                                label: _vm.$t(
                                  "report_management.modal_report.form.link"
                                ),
                                rules: _vm.model.form.rules.link,
                                "col-size": 12,
                              },
                              model: {
                                value: _vm.form.link,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "link", $$v)
                                },
                                expression: "form.link",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.form.type === "POWERBI"
                      ? _c(
                          VRow,
                          { staticClass: "mt-1" },
                          [
                            _c(VCol, { attrs: { cols: "12" } }, [
                              _c(
                                "div",
                                { staticClass: "mb-2 col-md-12" },
                                [
                                  _c(VCombobox, {
                                    attrs: {
                                      label: _vm.$t(
                                        "report_management.modal_report.form.update_hours"
                                      ),
                                      multiple: "",
                                      chips: "",
                                      outlined: "",
                                      rules: _vm.model.form.rules.update_hours,
                                      dense: "",
                                      attach: "true",
                                    },
                                    model: {
                                      value: _vm.form.update_hours,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "update_hours", $$v)
                                      },
                                      expression: "form.update_hours",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      VRow,
                      { staticClass: "mt-1" },
                      [
                        _c(VCol, { attrs: { cols: "12" } }, [
                          _c(
                            "div",
                            { class: "mb-2 col-md-12" },
                            [
                              _c(VTextarea, {
                                attrs: {
                                  label: _vm.$t(
                                    "report_management.modal_report.form.description"
                                  ),
                                  rules: _vm.model.form.rules.description,
                                  outlined: "",
                                  "auto-grow": "",
                                  rows: "5",
                                },
                                model: {
                                  value: _vm.form.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "description", $$v)
                                  },
                                  expression: "form.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { staticClass: "mt-1" },
                      [
                        _c(VCol, { attrs: { cols: "6" } }, [
                          _c(
                            "div",
                            { class: "mb-2 col-md-12" },
                            [
                              _c(VSwitch, {
                                attrs: {
                                  label: _vm.$t(
                                    "report_management.modal_report.form.maintenance"
                                  ),
                                  inset: "",
                                  filled: _vm.readonly,
                                  outlined: !_vm.readonly,
                                  readonly: _vm.readonly,
                                  "hide-details": "auto",
                                },
                                model: {
                                  value: _vm.form.maintenance,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "maintenance", $$v)
                                  },
                                  expression: "form.maintenance",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  VRow,
                  { staticClass: "mt-4", attrs: { justify: "center" } },
                  [
                    _c(
                      VBtn,
                      {
                        staticClass: "mr-2",
                        attrs: { outlined: "" },
                        on: { click: _vm.onClose },
                      },
                      [_vm._v("Cancelar")]
                    ),
                    _c(
                      VBtn,
                      {
                        staticClass: "mr-2",
                        attrs: { color: "primary" },
                        on: { click: _vm.onSave },
                      },
                      [_vm._v("Guardar")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }